import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "ui/components/dialog";
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "ui/components/form";
import ButtonWithLoading from "@/components/button-with-loading";
import { Input } from "ui/components/input";
import { Form } from "react-crud-form";
import { FormLabel } from "components/form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { repoSchema } from "./schema";
import { useRepoMutation } from "../../mutation";
import { useProject } from "@/modules/work/projects/context";
import React from "react";
import { FormActions } from "components/form/actions";

export default function CreateRepoDialog({ open, onOpenChange, project }) {
  const { id } = useProject();
  const { mutateAsync: createRepoMutate } = useRepoMutation();

  const form = useForm({
    resolver: zodResolver(repoSchema),
    defaultValues: {
      name: "",
    },
  });

  const handleCreate = async (context) => {
    // `project` prop is the project slug (used in the repo URL); `id` is the project's id.
    const values = {
      suffix: context.values.name,
      projectId: id,
      projectSlug: project,
    };

    await createRepoMutate({ values });
    form.reset();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create Repo</DialogTitle>
          <DialogDescription>
            Enter a suffix to complete your GitHub repository name.
          </DialogDescription>
        </DialogHeader>
        <Form form={form} create={handleCreate} itemId="+" schema={repoSchema}>
          {({ isCreating, createItem, isDirty, isNewItem }) => (
            <div className="grid gap-4">
              <FormField
                control={form.control}
                name="name"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel required={true}>
                      Repo Name
                    </FormLabel>
                    <FormControl>
                      <div className="flex items-center text-sm">
                        <p className="bg-zinc-100 text-muted-foreground px-3 py-2 rounded-l-md whitespace-nowrap flex-shrink-0">
                          {`https://github.com/7span/${project}-`}
                        </p>
                        <Input
                          {...field}
                          className="rounded-r-md rounded-l-none"
                          placeholder="frontend"
                        />
                      </div>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormActions
                isNewItem={isNewItem}
                isCreating={isCreating}
                isDirty={form.getValues("name")}
                createItem={createItem}
                onCancel={onOpenChange}
                teleport={false}
                className="justify-end"
              />
            </div>
          )}
        </Form>
      </DialogContent>
    </Dialog>
  );
}
